import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './plan.css';
import Navbar from '../components/navbar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
const PlanVendor = () => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [error, setError] = useState(null);

  // Declare background color classes
  const bgClasses = ['bg-color-1', 'bg-color-2', 'bg-color-3', 'bg-color-4', 'bg-color-5'];

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/getAllPlan`)
      .then(response => {
        if (response.data.status === 'ok') setPlans(response.data.data);
        else setError(response.data.message);
      })
      .catch(error => setError(error.message));

    const vendorId = localStorage.getItem('vendorId');
    axios.get(`${process.env.REACT_APP_API_URL}/getSelectedPlan/${vendorId}`)
      .then(response => {
        if (response.data.status === 'ok') setSelectedPlanId(response.data.data.planId);
        else setError(response.data.message);
      })
      .catch(error => setError(error.message));
  }, []);

  const handleSelectPlan = async (planId, planPrice) => {
    const vendorId = localStorage.getItem('vendorId');
    if (planPrice > 0) {
      initiateRazorpay(planId, planPrice, vendorId);
    } else {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/selectPlanVendor`, {
          planId, planPrice, vendorId, paymentId: null
        });
        if (response.data.status === 'ok') {
          setSelectedPlanId(planId);
         
           toast.success('Plan selected successfully.');
          window.location.href = "/";
        } else {
          setError(response.data.message);
        }
      } catch (error) {
        setError(error.message);
      }
    }
  };

  const initiateRazorpay = (planId, planPrice, vendorId) => {
    const amountInPaise = planPrice * 100;
    const options = {
      key: "rzp_live_fuifIDFQLxFGf3",
      amount: amountInPaise,
      currency: "INR",
      name: "Market Fashion",
      description: "Plan Purchase",
      image: "/logo.png",
      handler: async function (response) {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/selectPlanVendor`, {
          planId, planPrice, vendorId, paymentId: response.razorpay_payment_id
        });
        if (res.data.status === 'ok') {
          setSelectedPlanId(planId);
          alert('Payment successful!');
          window.location.href = "./Dashboard";
        } else {
          setError(res.data.message);
        }
      },
      theme: { color: "#f47521" }
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <>

      <Navbar />
        <ToastContainer position="top-center" autoClose={3000} />
      <section className="membership-banner text-white">
        <div className="container text-center">
          <h1>Upgrade Your Business Visibility</h1>
          <p>Connect with global buyers and elevate your brand with our vendor plans</p>
        </div>
      </section>

      <section className="plan-section">
        <div className="container">
          <h2 className="text-center mb-5">Choose Your Vendor Plan</h2>
          {error && <p className="error-message">{error}</p>}
          <div className="row">
            {plans.map((plan, index) => (
              <div key={plan._id} className="col-md-4 mb-4">
                <div className={`plan-card ${bgClasses[index % bgClasses.length]} ${selectedPlanId === plan._id ? 'active' : ''}`}>
                 <Link to={`/PlanView/${plan._id}`}>
  <h4 className="plan-title">{plan.planName}</h4>
</Link>

                  <h2 className="plan-price">₹{plan.planPrice}</h2>
                  <button
                    className="btn plan-btn w-100 mt-3"
                    onClick={() => handleSelectPlan(plan._id, plan.planPrice)}
                  >
                    {selectedPlanId === plan._id ? 'Currently Active' : 'Get Started'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PlanVendor;
